import { HStack, Text, TextWithLinks, VStack } from 'ui_2';

type Props = {
  availability: string;
  className?: string;
  displayFlag?: string;
};

export const ProductAvailability = ({
  availability,
  className = '',
  displayFlag,
}: Props) => {
  return (
    <VStack className={`w-full ${className}`}>
      <HStack className='items-center justify-between'>
        <Text font='sm'>Availability</Text>
        {displayFlag && <Text font='medium-lg'>{displayFlag}</Text>}
      </HStack>
      <HStack className='w-full rounded-[10px] bg-blue-200 px-3 py-2'>
        <TextWithLinks font='xs' linkTarget='_blank' text={availability} />
      </HStack>
    </VStack>
  );
};
